import React, { useContext } from 'react';
import { Table, Thead, Tbody, Tr, Th } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import EkovillaContext from '../contexts/EkovillaContext';

import EkovillaRow from './EkovillaRow';
import TextBox from './TextBox';

function EkovillaTable() {

    const { ekovilla } = useContext(EkovillaContext);

    return (
        <div className="pb-8">
            <h1 className="pb-4 font font-bold text-xl sm:text-xl md:text-2xl xl:text-3xl">Testaa päästölukemat Ekovillan eristeillä</h1>
            <div className="w-full xl:hidden pb-16">
                <TextBox />
            </div>
            <Table className="table-auto w-full">
                <Thead>
                    <Tr>
                        <Th className="text-left pl-1 text-sm xl:text-base">Rakennusosa</Th>
                        <Th className="text-left pl-1 text-sm xl:text-base">Tuote</Th>
                        <Th className="text-sm xl:text-base">Pinta-ala m<sup>2</sup></Th>
                        <Th className="text-sm xl:text-base">Eristepaksuus mm</Th>
                        <Th className="text-sm xl:text-base">Eriste m<sup>3</sup></Th>
                        <Th className="text-sm xl:text-base">Eriste Kg</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {Object.values(ekovilla).map((row, index) => (
                        <EkovillaRow key={index} index={index} row={row} />
                    ))}
                </Tbody>
            </Table>
        </div>
    )
}

export default EkovillaTable;